import { FormikProps } from "formik";
import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import {
  notifyBugsnagError,
  removeInitialSpace,
  showToast,
} from "../../../../common/utils/Functions";
import useFetch from "../../../../hooks/useFetch";
import {
  organizationAddEditType,
  partnerSelectType,
  referredBySelectType,
} from "../../../../types/organization";
import InputField from "../../../theme/InputField";
import ReactSelectField from "../../../theme/ReactSelectField";
import ThemeButton from "../../../theme/ThemeButton";
import styles from "../addEditOrgnaization.module.scss";
import { IoMdClose } from "react-icons/io";

interface Iprops {
  formik: FormikProps<organizationAddEditType>;
  currentStep?: number;
  setCurrentStep: (step: number) => void;
  editModal: boolean;
  partner_details?: any;
  referred_details?: any
  industry_details?: any
}

const Step2 = ({
  formik,
  currentStep,
  setCurrentStep,
  editModal,
  partner_details,
  referred_details,
  industry_details
}: Iprops) => {
  const [listOptions, setListOptions] = useState([]);
  const [referredByOptions, setReferredByOptions] = useState([]);
  const [industryOptions, setIndustryOptions] = useState([]);

  /** Api definition */
  const [partnerListApi, { response, error }] = useFetch("/partners/list", {
    method: "post",
  });

  const [referredByListApi, { response: referredByResponse, error: referredByError }] = useFetch("/referrers/list", {
    method: "post",
  });

  /** Handle partnerapi response */
  useEffect(() => {
    if (response) {
      setListOptions(
        response.data.list.map((item: partnerSelectType) => ({
          value: item.id,
          label: item.name,
          isDisabled: !!item?.allow_third_party_integration,
        })),

      );
      setIndustryOptions(response.data.industry_list?.map((item: any) => ({
        value: item.id,
        label: item.name,
      })))
    }
    if (error) {
      showToast(error.message as string, "error");
    }
  }, [response, error]);

  useEffect(() => {
    try {
      partnerListApi({
        start: 0,
        limit: -1,
        search: "",
        is_active: 1,
      });
    } catch (e: any) {
      notifyBugsnagError(e, { api: "partnerlist" });
    }
  }, []);

  /** Handle referredByListApi response */
  useEffect(() => {
    if (referredByResponse) {
      setReferredByOptions(
        referredByResponse.data.list.map((item: referredBySelectType) => ({
          value: item.id,
          label: item.name,
        }))
      );
    }
    if (referredByError) {
      showToast(referredByError.message as string, "error");
    }
  }, [referredByResponse, referredByError]);

  useEffect(() => {
    try {
      referredByListApi({
        start: 0,
        limit: -1,
        search: "",
        is_active: 1,
      });
    } catch (e: any) {
      notifyBugsnagError(e, { api: "referredByListApi" });
    }
  }, []);

  return (
    <Row className="g-xl-4 g-3">
      <Col
        xs={12}
        style={{
          cursor: editModal ? "not-allowed" : "pointer",
        }}
      >
        <div style={{ position: 'relative' }}>
          <ReactSelectField
            name="partner"
            options={listOptions}
            label="Partner (Optional)"
            placeholder="Select Partner"
            className="form_select"
            formik={formik}
            isDisabled={
              editModal && partner_details?.allow_third_party_integration == 1
            }
          />
          {formik.values.partner && (
            <div
              style={{
                position: 'absolute',
                right: '30px',
                top: '65%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                zIndex: 1,
                display: 'flex',
                alignItems: 'center',
                padding: '0 8px',
              }}
              onClick={(e) => {
                e.stopPropagation();
                formik.setFieldValue('partner', null);
                formik.setFieldTouched('partner', false);
              }}
            >
              <IoMdClose size={20} />
            </div>
          )}
        </div>

      </Col>
      {formik.values.partner && (
        <Col xs={12}>
          <InputField
            formik={formik}
            style={{
              cursor: editModal ? "not-allowed" : "",
            }}
            name="apiKey"
            label="Api Key (Optional)"
            placeholder="Enter Api Key"
            disabled={editModal}
            onChange={(e) =>
              formik.setFieldValue("apiKey", removeInitialSpace(e.target.value))
            }
          />
        </Col>
      )}
      <Col
        xs={12}
        style={{
          cursor: "pointer",
        }}
      >
        <div style={{ position: 'relative' }}>
          <ReactSelectField
            name="referrer"
            options={referredByOptions}
            label="Referred By (Optional)"
            placeholder="Select Referrer"
            className="form_select"
            formik={formik}
          />
          {formik.values.referrer && (
            <div
              style={{
                position: 'absolute',
                right: '30px',
                top: '65%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                zIndex: 1,
                display: 'flex',
                alignItems: 'center',
                padding: '0 8px',
              }}
              onClick={(e) => {
                e.stopPropagation();
                formik.setFieldValue('referrer', null);
                formik.setFieldTouched('referrer', false);
              }}
            >
              <IoMdClose size={20} />
            </div>
          )}
        </div>
      </Col>
      <Col
        xs={12}
        style={{
          cursor: "pointer",
        }}
      >
        <div style={{ position: 'relative' }}>
          <ReactSelectField
            name="industry"
            options={industryOptions}
            label="Industry (Optional)"
            placeholder="Select Industry"
            className="form_select"
            formik={formik}
          />
          {formik.values.industry && (
            <div
              style={{
                position: 'absolute',
                right: '30px',
                top: '65%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                zIndex: 1,
                display: 'flex',
                alignItems: 'center',
                padding: '0 8px',
              }}
              onClick={(e) => {
                e.stopPropagation();
                formik.setFieldValue('industry', null);
                formik.setFieldTouched('industry', false);
              }}
            >
              <IoMdClose size={20} />
            </div>
          )}
        </div>
      </Col>
      <Col xxl={12} xl={12} className="text-center">
        <div className={styles.butonSteps}>
          <ThemeButton variant="secondary" onClick={() => setCurrentStep(1)}>
            Back
          </ThemeButton>
          <ThemeButton onClick={() => formik.handleSubmit()}>Next</ThemeButton>
        </div>
      </Col>
    </Row>
  );
};

export default Step2;
